// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"816":"b1597733","958":"b1597733"}[chunkId] + ".chunk.css";
};